import React, { useState } from "react";
import ReactAvatar from "react-avatar";
import cns from "classnames";
import {
  Badge,
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemText,
  makeStyles
} from "@material-ui/core";
import { Star, StarBorder } from "@material-ui/icons";
import { ThemeType, mixins } from "@theme";
import { MenuItem } from "./types";

type SubMenuProps = {
  className?: string;
  name: string;
  onClick?: (item: MenuItem) => void;
  icon?: JSX.Element;
  items: MenuItem[];
  open?: boolean;
};

type ItemProps = {
  item: MenuItem;
  index: number;
  onClick?: (item: MenuItem) => void;
};

const Item = (props: ItemProps) => {
  const { item, index, onClick } = props;

  const [isHovering, setIsHovering] = useState(false);
  const classes = useStyles({});

  return (
    <ListItem
      key={item.path + index}
      button
      onClick={() => (item.onClick ? item.onClick() : onClick(item))}
      className={cns(classes.listSubItem, classes.listItem, {
        [classes.active]: item.active
      })}
    >
      <Badge
        color={"primary"}
        className={classes.notifBadge}
        badgeContent={item.badgeContent}
        data-test="Badge"
        data-test-value={item.badgeContent}
      >
        <ReactAvatar size={"26"} maxInitials={3} name={item.label} />
      </Badge>
      <ListItemText className={classes.textOverflowEllipsis} primary={item.label} />
      <IconButton
        onMouseOver={() => setIsHovering(true)}
        onMouseOut={() => setIsHovering(false)}
        onClick={() => item.onFavorite(item.label)}
      >
        {item.favorite ? (
          <Star style={{ fill: "gold" }} />
        ) : (
          <StarBorder style={{ fill: isHovering ? "gold" : "transparent" }} />
        )}
      </IconButton>
    </ListItem>
  );
};

export const SubMenu = (props: SubMenuProps) => {
  const classes = useStyles({});

  return (
    <div className={cns(classes.root, props.className)}>
      <List component={"nav" as any} classes={{ root: classes.listRoot }}>
        <Collapse in={props.open} timeout="auto" unmountOnExit>
          <List disablePadding>
            {props.items.map((item, index) => {
              return <Item key={index} item={item} index={index} />;
            })}
          </List>
        </Collapse>
      </List>
    </div>
  );
};

const useStyles = makeStyles((theme: ThemeType) => ({
  ...mixins.withListItem(theme),
  root: {
    width: "100%",
    maxWidth: 360
  },

  listRoot: {
    padding: 0
  },

  active: {
    borderLeft: `3px solid ${theme.palette.primary.main}`
  },

  notifBadge: {
    color: "#fff"
  },

  padding: {
    paddingLeft: 0
  },

  textOverflowEllipsis: {
    paddingLeft: 20,
    textOverflow: "ellipsis!important",
    whiteSpace: "nowrap",
    overflow: "hidden!important"
  }
}));
